export const THIRD_PARTY_SENSOR_LINKED_APPLIANCES_CARD_ENGLISH_LOCALE = {
  title: "Linked appliances",
  toasts: {
    removeThirdPartySensorLinkedAppliances: {
      success: {
        summary: "Associations removed",
        detail: "All selected associations have been successfully removed.",
      },
      error: {
        summary: "Removal failed",
        detail: "No association could be removed. Please try again later.",
      },
      warn: {
        summary: "Partial removal",
        detail: "Some associations couldn’t be removed. Please try again later.",
      },
    },
  },
};
